module.exports = __webpack_public_path__ + "static/media/savan_nahar.61a02439.jpg";